 
// src/redux/reducers/countryReducer.js
import {
    FETCH_COUNTRY_FAILURE,
    FETCH_COUNTRY_REQUEST,
    FETCH_COUNTRY_SUCCESS, 
    SET_SELECTED_COUNTRY 
  } from '../types';
  
  const initialState = {
    loading: false,
    countryList: [],
    selectedCountryId: null, 
    error: null,
  };
  
  const countryReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COUNTRY_REQUEST:
        return { ...state, loading: true };
      case FETCH_COUNTRY_SUCCESS:
        return { ...state, loading: false, countryList: action.payload };
      case FETCH_COUNTRY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_COUNTRY:
        return { ...state, selectedCountryId: action.payload };
      default:
        return state;
    }
  };
  
  export default countryReducer;
  